const exportData = {
    test: "/test",
    main: "/",
    login: "/login",

    menu_1: "/ai_images_generator",
    menu_2: "/ai_avatars_generator",
    menu_3: "/high_resolution_images",
    menu_4: "/transform_styles",
    menu_5: "/reconstruct_images",
    menu_6: "/enlarge_images",

    menu_7: "/ai_videos_generator",
    menu_8: "/high_resolution_videos",
    menu_9: "/change_videos_mood",
    menu_10: "/text_to_video",

    profile: "/profile",

    term: "/term",

    pay: '/pay',
    pay_history: '/pay_history',
    myart_history: '/myart_history',
    myart_gallery: '/myart_gallery',

    art_detail: '/art_detail'
}

export default exportData;
